import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import { getOnlyNumbers } from 'Participant/ducks'
import clients from 'redux/clients'

const getZipCode = value => {
  const number = value ? getOnlyNumbers(value) : ''
  return { value, number }
}

class Form extends Component {
  constructor (props) {
    super(props)
    this.state = {
      zipCode: this.props.zipCode && getZipCode(this.props.zipCode.value),
      number: { value: this.props.number && this.props.number.value },
      complement: this.props.complement,
      reference: this.props.reference,
      city: this.props.city && this.props.city.value,
      state: this.props.state && this.props.state.value,
      street: {
        value: this.props.street.value || this.props.street.valueParticipant,
        // disabled: this.props.street.disabled
        disabled: false
      },
      district: {
        value: this.props.district.value || this.props.district.valueParticipant,
        disabled: this.props.district.disabled
      },
      dirty: false,
      loaded: false,
      isLoading: this.props.isLoading,
      isValid: true,
      isUpdating: this.props.participant.isUpdating
    }
  }

  componentDidUpdate (prevProps) {
    this.changeAddress(prevProps)

    if (!this.props.participant.updatedSuccessfully) return

    setTimeout(() => {
      this.setState({ dirty: false })
      this.props.expireUpdatedParticipant()
    }, 3000)
  }

  changeAddress = (prevProps) => {
    if (this.props.isLoading) {
      return
    }

    if (
      this.props.street.value !== prevProps.street.value ||
      this.props.streetType.value !== prevProps.streetType.value
    ) {
      this.setState({
        street: {
          value: this.props.streetType.value + ' ' + this.props.street.value
        }
      })
    }

    if (
      this.props.district.value !== prevProps.district.value
    ) {
      this.setState({
        district: { value: this.props.district.value }
      })
    }
  }

  buttonProps = () =>
    this.props.participant.updatedSuccessfully
      ? { text: 'Salvo', className: 'btn btn-sm btn-featured bg-success' }
      : { text: 'Salvar', className: 'btn btn-sm btn-featured' }

  validateZipCode = async (zipCodeValue) => {
    const { number, value } = getZipCode(zipCodeValue)
    const isValid = this.isZipCodeValid(number)
    const zipCode = { value, number, isValid }
    await this.setState({ zipCode, dirty: true })
    return zipCode
  }

  handleZipCode = async ({ target: { value } }) => {
    if (value === this.state.zipCode.focusValue) {
      return
    }

    const zipCode = await this.validateZipCode(value)
    if (zipCode.isValid && zipCode.number.length === 8) {
      this.props.fetchShipping(zipCode.number)
    }
  }

  onFocusZipCode = async (e) => {
    this.setState({
      zipCode: {
        focusValue: e.value
      }
    })
  }

  isZipCodeValid = value => !!value && value.length === 8

  isNumberValid = value => {
    return !isNaN(parseFloat(value)) && isFinite(value)
  }

  validateNumber = () => {
    const { value } = this.state.number
    const isValid = this.isNumberValid(value)
    this.setState({ number: { value, isValid }, dirty: true })
  }

  isStreetValid = value => !!value && value.length > 2

  buttonDisabled = () => {
    const { zipCode, number, dirty, street } = this.state
    const enabled =
      dirty &&
      zipCode.number !== '00000000' &&
      this.isZipCodeValid(zipCode.number) &&
      this.isNumberValid(number.value) &&
      this.isStreetValid(street.value) &&
      !this.props.cepError &&
      !this.props.isLoading

    return !enabled
  }

  isValid = () => {
    let isValid = true
    const { complement, reference } = this.state
    const nameValidator = /^[\wÀ-Ÿ\-&\s()]+(?![http:https:www.])$/

    if (!complement.value) {
      this.setState({
        complement: {
          value: complement.value,
          disabled: complement.disabled,
          error: 'O complemento é obrigatório'
        }
      })
      isValid = false
    }

    if (!nameValidator.test(complement.value)) {
      this.setState({
        complement: {
          value: complement.value,
          disabled: complement.disabled,
          error: 'Digite um complemento válido'
        }
      })
      isValid = false
    }

    if (reference.value) {
      if (!nameValidator.test(reference.value)) {
        this.setState({
          reference: {
            value: reference.value,
            disabled: reference.disabled,
            error: 'Digite uma referência válida'
          }
        })
        isValid = false
      }
    }

    this.setState({ isValid })
  }

  handleInputValid (input) {
    if (input && input.error) return false
    return true
  }

  handleOnClick = async () => {
    if (!this.state.isValid) return

    this.setState({ isUpdating: true })
    await this.submitShipping()
    this.setState({ isUpdating: false })
  }

  submitShipping = async () => {
    let bodyCheckout = await this.formatToSend()
    clients.cloudloyalty.client
      .put('/v1/carts/me/shipping', bodyCheckout)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  formatToSend = async () => {
    let state = this.state
    const participant = await this.getParticipant()

    return {
      customer: participant,
      shippingAddress: {
        city: state.city,
        complement: state.complement.value,
        district: state.district.value,
        number: state.number.value,
        reference: state.reference.value,
        state: state.state,
        street: state.street.value,
        zipCode: state.zipCode.value.replace(/\D/g, '')
      }
    }
  }

  getParticipant = async () => {
    return clients.cloudloyalty.client
      .get('/v1/participants/me')
      .then((res) => {
        return this.handleCustomer(res.data)
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }

  handleCustomer (data) {
    return {
      documentNumber: data.documentNumber,
      email: data.emails[0].email,
      genderType: data.genderType,
      name: data.name,
      personType: data.persontype,
      phones: data.phones[0]
    }
  }

  render () {
    let cepValid = this.state.zipCode && this.state.zipCode.isValid
    let streetDisabled = true
    let districtDisabled = true

    if (this.props.cepError) cepValid = false
    if (!this.props.isLoading && this.props.city.value !== '') {
      if (this.props.street.value === '') streetDisabled = false
      if (this.props.district.value === '') districtDisabled = false
    }

    return (
      <div className='address-form col-12 mt-1 px-2'>
        <div className='row'>
          <Input
            id='address-zipCode'
            label='CEP'
            className='col-12 col-md-6 mt-2'
            value={this.state.zipCode.value === '00000000' ? '' : this.state.zipCode.value}
            onChange={e =>
              this.setState({
                zipCode: { value: e.target.value, isValid: null },
                dirty: true
              })
            }
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
            required
            disabled={
              this.props.zipCode.value !== '' &&
              this.props.zipCode.disabled === 'true'
            }
            data-error='Digite um CEP válido'
            valid={cepValid}
            onBlur={this.handleZipCode}
            onFocus={(e) => this.onFocusZipCode(e)}
          />
          <Input
            id='address-street'
            label='Logradouro'
            className='col-12 col-md-6 mt-2'
            value={this.state.street.value}
            onChange={e =>
              this.setState({
                street: { value: e.target.value, isValid: null },
                dirty: true
              })
            }
            maxLength='100'
            required
            disabled={streetDisabled}
            data-error='Digite um Logradouro'
            valid={this.isStreetValid(this.state.street.value)}
          />
          <Input
            id='address-number'
            label='Número'
            className='col-12 col-md-6 mt-2'
            value={this.state.number.value}
            onChange={e =>
              this.setState({
                number: { value: e.target.value, isValid: null },
                dirty: true
              })
            }
            required
            disabled={
              this.props.number && this.props.number.disabled === 'true'
            }
            data-error='Digite o seu número ou s/n para sem número'
            valid={this.state.number.isValid}
            onBlur={this.validateNumber}
          />
          <Input
            id='address-complement'
            label='Complemento'
            name='complement'
            required
            className='col-12 col-md-6 mt-2'
            value={this.state.complement.value}
            maxLength={20}
            onChange={e =>
              this.setState({
                complement: { value: e.target.value },
                dirty: true
              })
            }
            disabled={
              this.props.complement && this.props.complement.disabled === 'true'
            }
            data-error={this.state.complement && this.state.complement.error}
            valid={this.handleInputValid(this.state.complement)}
            onBlur={this.isValid}
          />
          <Input
            name='reference'
            id='address-reference'
            label='Ponto de Referência'
            className='col-12 col-md-6 mt-2'
            value={this.state.reference.value}
            onChange={e =>
              this.setState({
                reference: { value: e.target.value },
                dirty: true
              })
            }
            disabled={
              this.props.reference && this.props.reference.disabled === 'true'
            }
            data-error={this.state.reference && this.state.reference.error}
            valid={this.handleInputValid(this.state.reference)}
            onBlur={this.isValid}
          />
          <Input
            id='address-district'
            label='Bairro'
            className='col-12 col-md-6 mt-2'
            value={this.state.district.value}
            onChange={e =>
              this.setState({
                district: { value: e.target.value, isValid: null },
                dirty: true
              })
            }
            maxLength='100'
            required
            disabled={districtDisabled}
            data-error='Digite um Bairro'
            valid={this.handleInputValid(this.state.district)}
          />
          <Input
            id='address-city'
            label='Cidade'
            className='col-12 col-md-6 mt-2'
            value={this.props.city.value}
            required
            disabled='true'
          />
          <Input
            id='address-state'
            label='Estado'
            className='col-12 col-md-6 mt-2'
            value={this.props.state.value}
            required
            disabled='true'
          />
          <div className='col-12 col-md-6 mt-2'>
            <Button
              id={'btn-address-submit'}
              className='btn-featured form-field btn-sm txt-center'
              text='Salvar'
              onClick={this.handleOnClick}
              disabled={this.buttonDisabled()}
              {...this.buttonProps()}
              loading={this.state.isUpdating}
            />
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string,
  valueParticipant: PropTypes.string,
  disabled: PropTypes.string
})

Form.propTypes = {
  street: PropTypes.shape({
    valueParticipant: PropTypes.string,
    disabled: PropTypes.string,
    value: PropTypes.string
  }),
  streetType: valueType,
  district: PropTypes.shape({
    valueParticipant: PropTypes.string,
    disabled: PropTypes.string,
    value: PropTypes.string
  }),
  city: valueType,
  state: valueType,
  zipCode: valueType,
  number: valueType,
  complement: valueType,
  reference: valueType,
  fetchShipping: PropTypes.func.isRequired,
  participant: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  cepError: PropTypes.bool.isRequired,
  expireUpdatedParticipant: PropTypes.func.isRequired
}

export default Form



// WEBPACK FOOTER //
// ./src/Participant/Address/Form.js